import axios from "axios";
import config from "../config";

let automazione = new Object({
  fetchSetup: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/fetchSetup",
        data: {},
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveGlobalInstructions: instructions => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/saveGlobalInstructions",
        data: { instructions: instructions },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveAssistant: assistant => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/saveAssistant",
        data: { assistant: assistant },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  removeAssistant: id => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/removeAssistant",
        data: { id: id },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchLogs: ctx => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/fetchLogs",
        data: { ctx: ctx },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  sendMockWhatsapp: payload => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/sendMockWhatsapp",
        data: { payload: payload },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchOperatorTestConversation: (assistantId, reset = false) => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/fetchOperatorTestConversation",
        data: { assistant_id: assistantId, reset: reset },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  sendOperatorGuestMessage: payload => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/sendOperatorGuestMessage",
        data: payload,
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  answerOperatorChatbot: payload => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/answerOperatorChatbot",
        data: payload,
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchOpenRouterCatalog: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/fetchOpenRouterCatalog",
        data: {},
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  forwardOpenRouterChat: payload => {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/automazione/forwardOpenRouterChat",
        data: { payload: payload },
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
});

export default automazione;
